export const minHeightDvh = {
  minHeight: "100vh",
  "@supports (min-height: 100dvh)": { minHeight: "100dvh" },
} as const;

export const heightDvhMinus = (px: number) =>
  ({
    height: `calc(100vh - ${px}px)`,
    "@supports (height: 100dvh)": { height: `calc(100dvh - ${px}px)` },
  }) as const;

export const safeAreaTop = {
  paddingTop: "env(safe-area-inset-top)",
} as const;

export const safeAreaX = {
  paddingLeft: "env(safe-area-inset-left)",
  paddingRight: "env(safe-area-inset-right)",
} as const;

export const safeAreaBottom = {
  paddingBottom: "env(safe-area-inset-bottom)",
} as const;
